import { z } from 'zod';

const flexPoolSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  companyId: z.string(),
  companyName: z.string(),
  departmentNames: z.array(z.string()),
  departments: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    })
  ),
});

export const flexPoolsSchema = z.array(flexPoolSchema);

export type GetFlexPoolsResponse = z.infer<typeof flexPoolsSchema>;
